import './table.scss';import Sloth from '../Sloth';


/** WEBPACK FOOTER **
 ** ./components/Table/table.js
 **/